import styled from 'styled-components'

export const TitleText = styled.p<IText>`
    font-size: 16px;
    color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
`

export const BodyText = styled.p<IText>`
    font-size: 14px;
    color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
    line-height: 20px;
`

export const OtherText = styled.p<IText>`
    font-size: 12px;
     color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
    line-height:16px;
`

export const ParagraphText = styled.p<IText>`
    font-size: 10px;
    color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
   ${(props) => props.color && `color: ${props.color}`}
`

export const Heading3 = styled.h3<IText>`
   color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
`

export const Heading2 = styled.h2<IText>`
    color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
`

export const Heading1 = styled.h1<IText>`
   color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
`

interface IText {
    weight?: string
    color?: string
    important?: boolean
    grey?: boolean
}

export const Head1 = styled.h1<IText>`
    font-size: 30px;
   color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
    line-height:38px;
`

export const Head2 = styled.h2<IText>`
    font-size: 24px;
   color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
    line-height:30px;
`

export const Head4 = styled.h4<IText>`
    font-size: 16px;
    color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
    line-height:20px;
`

export const Head5 = styled.h5<IText>`
    font-size: 14px;
   color: ${props => props.grey ? props.theme.greyText : props.theme.textColor};
    ${(props) => props.weight && `font-weight: ${props.weight};`}
    ${(props) => props.color && `color: ${props.color};`}
    line-height:18px
`